import { CamundaAuthError, CamundaBaseService } from "@/lib/camunda/base-service";
import { ENV_CONFIG } from "@/lib/env-config";

export type RpaWorkerStatus = "OK" | "STALE" | "DOWN" | "ERP_NOT_READY" | "BUSY_TOO_LONG" | "ERROR";

export interface RpaWorkerStatusDto {
  workerId: string;
  hostname: string | null;
  vmAddress: string | null;
  status: RpaWorkerStatus;
  lastHeartbeatAt: string | null;
  lastFailureAt: string | null;
  lastRecoveredAt: string | null;
  lastTaskId: string | null;
  taskInProgress: boolean | null;
  erpReady: boolean | null;
  sessionReady: boolean | null;
  camundaReachable: boolean | null;
  lastError: string | null;
  version: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface RpaMonitorConfigDto {
  monitoredWorkerId: string;
  rpaMonitorWorkerIdEnv: string | null;
  source: "RPA_MONITOR_WORKER_ID" | "application-default";
}

export class RpaMonitorService extends CamundaBaseService {
  static async getWorkers(): Promise<RpaWorkerStatusDto[]> {
    const url = `${ENV_CONFIG.getBackendApiBaseUrl()}/rpa/workers`;
    const authHeaders = await this.getAuthHeaders();
    const headers = new Headers(authHeaders);
    headers.set("Content-Type", "application/json");
    const response = await fetch(url, {
      headers,
    });

    if (response.status === 401) {
      throw new CamundaAuthError(
        "Sesión expirada o no autorizada en el monitor RPA.",
        "UNAUTHORIZED",
        401,
      );
    }

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }

  static async getMonitorConfig(): Promise<RpaMonitorConfigDto> {
    const url = `${ENV_CONFIG.getBackendApiBaseUrl()}/rpa/monitor-config`;
    const authHeaders = await this.getAuthHeaders();
    const headers = new Headers(authHeaders);
    headers.set("Content-Type", "application/json");
    const response = await fetch(url, {
      headers,
    });

    if (response.status === 401) {
      throw new CamundaAuthError(
        "Sesión expirada o no autorizada en el monitor RPA.",
        "UNAUTHORIZED",
        401,
      );
    }

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }
}
